/**
 * Reusable Button component
 * @param {string} variant - 'primary' | 'secondary' | 'danger' | 'ghost'
 * @param {boolean} disabled - Disable button
 * @param {function} onClick - Click handler
 * @param {object} style - Additional inline styles
 * @param {ReactNode} children - Button content
 */
export function Button({ 
  children, 
  variant = 'primary', 
  disabled = false, 
  onClick, 
  style = {},
  ...props 
}) {
  const baseStyle = {
    border: "none",
    borderRadius: 10,
    padding: "10px 18px",
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: "'Cairo',sans-serif",
    fontSize: 13,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    gap: 8,
    opacity: disabled ? 0.6 : 1,
    transition: "all 0.2s ease",
  };

  const variants = {
    primary: {
      background: "linear-gradient(135deg,#4ecdc4,#38b2ac)",
      color: "#fff",
    },
    secondary: {
      background: "transparent",
      border: "1px solid #e2e8f0",
      color: "#4d6680",
    },
    danger: {
      background: "#ef4444",
      color: "#fff",
    },
    ghost: {
      background: "transparent",
      color: "#000000",
      padding: "5px 10px",
    },
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{ ...baseStyle, ...variants[variant], ...style }}
      {...props}
    >
      {children}
    </button>
  );
}
